export default __webpack_public_path__ + "static/media/book-5.887d7c09.jpeg";